export default `{
      bidStepType
      lots {
        lotId
        startAmount
        bidStep
      }
    }`